import { createAction, props } from '@ngrx/store';
import { IUserRolesResponse } from '../models/user-roles.model';

export const loadUserRoles = createAction('[UserRoles] Load UserRoles');

export const loadUserRolesSuccess = createAction('[UserRoles] Load UserRoles Success', props<{ response: IUserRolesResponse[] }>());

export const loadUserRolesFailure = createAction('[UserRoles] Load UserRoles Failure', props<{ error: any }>());
